import http from '@/services/http';

export interface WarehouseRecordItem {
  id: string;
  actor_user_id: string | null;
  actor_name: string;
  actor_email: string;
  actor_role: string;
  action: string;
  target_type: string;
  target_id: string | null;
  target_label: string | null;
  details_json: string | null;
  created_at: string;
}

export interface WarehouseRecordListResponse {
  items: WarehouseRecordItem[];
  total: number;
  limit: number;
  offset: number;
}

export interface WarehouseRecordFilters {
  limit?: number;
  offset?: number;
  action?: string;
  actorEmail?: string;
  search?: string;
}

export interface AdminStorageInfo {
  engine: string;
  host: string;
  port: number | null;
  database: string;
}

export interface AdminOverviewCounts {
  users: number;
  locations: number;
  variboxes: number;
  warehouse_records: number;
}

export interface AdminOverviewResponse {
  storage: AdminStorageInfo;
  counts: AdminOverviewCounts;
}

export async function listWarehouseRecords(filters: WarehouseRecordFilters = {}) {
  const response = await http.get<WarehouseRecordListResponse>('/api/admin/warehouse-records', {
    params: {
      limit: filters.limit ?? 50,
      offset: filters.offset ?? 0,
      action: filters.action || undefined,
      actor_email: filters.actorEmail || undefined,
      search: filters.search || undefined,
    },
  });

  return response.data;
}

export async function getAdminOverview() {
  const response = await http.get<AdminOverviewResponse>('/api/admin/overview');
  return response.data;
}